var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5395 0.857271C19.6802 0.388322 19.5395 0.0600586 18.883 0.0600586H16.6946C16.1318 0.0600586 15.8817 0.357059 15.741 0.685323C15.741 0.685323 14.6312 3.40522 13.0524 5.15596C12.5366 5.67181 12.3177 5.82812 12.0363 5.82812C11.8957 5.82812 11.6924 5.67181 11.6924 5.20286V0.857271C11.6924 0.294533 11.5361 0.0600586 11.0672 0.0600586H7.62823C7.28433 0.0600586 7.06549 0.325796 7.06549 0.56027C7.06549 1.09175 7.84707 1.2168 7.94086 2.68617V5.90628C7.94086 6.6097 7.81581 6.73476 7.53444 6.73476C6.79975 6.73476 4.98648 4.01486 3.92353 0.888534C3.70469 0.310164 3.50148 0.0600586 2.93874 0.0600586H0.750317C0.125053 0.0600586 0 0.357059 0 0.685323C0 1.26369 0.734686 4.13991 3.45459 7.93839C5.26785 10.5332 7.81581 11.9401 10.1293 11.9401C11.5205 11.9401 11.6924 11.6275 11.6924 11.096V9.12639C11.6924 8.50113 11.8175 8.37608 12.2708 8.37608C12.5991 8.37608 13.1462 8.53239 14.4436 9.78292C15.9286 11.2679 16.1787 11.9401 17.0072 11.9401H19.1956C19.8209 11.9401 20.1335 11.6275 19.9459 11.0178C19.7427 10.4082 19.0393 9.51718 18.1014 8.45423C17.5856 7.8446 16.8196 7.2037 16.6008 6.87544C16.2725 6.45339 16.3663 6.26581 16.6008 5.90628C16.6008 5.89065 19.2738 2.13906 19.5395 0.857271Z",
    fill: "#B3B3C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.d35b1b4771356bf0ab7c868fc5e61a18.svg";
export { ForwardRef as ReactComponent };